import { MOXIT_ORGANIZATIONS_FETCHED, ROLES_CHANGED } from '../actions/types';

export type RolesReducerState = {
  [key: string]: boolean;
};

const initialState: RolesReducerState = {};

const roles = (state = initialState, action) => {
  switch (action.type) {
    case ROLES_CHANGED:
      return { ...action.roles };

    case MOXIT_ORGANIZATIONS_FETCHED:
      return initialState;
    default:
      return state;
  }
};

export default roles;
